import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ac4324c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paper" }
const _hoisted_2 = {
  key: 0,
  class: "paperContainer"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_6 = { class: "question" }
const _hoisted_7 = { class: "questionHead" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "g-ml5 g-mr5" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = {
  key: 0,
  class: "pictures"
}
const _hoisted_12 = { class: "options" }
const _hoisted_13 = { class: "margin-left-5" }
const _hoisted_14 = {
  key: 1,
  class: "saveBtn g-flex-jc-center g-mb30"
}
const _hoisted_15 = {
  key: 2,
  class: "g-pt50 g-pb50"
}
const _hoisted_16 = {
  key: 0,
  class: "scoreContainer"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scoreMask" }, null, -1))
const _hoisted_18 = {
  ref: "scoreDialogRef",
  class: "scoreDialog"
}
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "scoreNum" }
const _hoisted_21 = {
  key: 0,
  class: "scoreflag"
}
const _hoisted_22 = {
  key: 1,
  class: "scoreflag"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 2,
  class: "scoreflag"
}
const _hoisted_26 = { class: "btn margin-top-40" }
const _hoisted_27 = { class: "btn" }
const _hoisted_28 = { class: "btn" }
const _hoisted_29 = { class: "btn margin-top-40" }
const _hoisted_30 = { class: "btn" }
const _hoisted_31 = { class: "btn" }
const _hoisted_32 = {
  key: 0,
  class: "detail-form g-flex-jc-start"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "radarContainer" }, null, -1))
const _hoisted_34 = { class: "questionList" }
const _hoisted_35 = { class: "card-header" }
const _hoisted_36 = { class: "title g-fw7 g-f16" }
const _hoisted_37 = { class: "icon" }
const _hoisted_38 = { class: "g-mr5" }
const _hoisted_39 = { class: "g-ml5" }
const _hoisted_40 = { class: "text" }
const _hoisted_41 = {
  key: 0,
  class: "pictures"
}
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "g-pl25 g-mt5" }
const _hoisted_44 = { class: "score g-pl25" }
const _hoisted_45 = {
  class: "g-fw7",
  color: ""
}
const _hoisted_46 = {
  key: 1,
  class: "questionLabelItem"
}
const _hoisted_47 = { class: "card-header" }
const _hoisted_48 = { class: "title g-fw7 g-f16" }
const _hoisted_49 = { class: "icon" }
const _hoisted_50 = { class: "g-mr5" }
const _hoisted_51 = { class: "g-ml5" }
const _hoisted_52 = { class: "text" }
const _hoisted_53 = {
  key: 0,
  class: "pictures"
}
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "g-pl25 g-mt5" }
const _hoisted_56 = { class: "score g-pl25" }
const _hoisted_57 = {
  class: "g-fw7",
  color: ""
}

import { nextTick, onMounted, onUnmounted, ref } from "vue";
import {
  Select,
  CloseBold,
  CircleCheckFilled,
  CircleCloseFilled,
} from "@element-plus/icons-vue";
import noData from "@/assets/operate/no_data.png";
import {
  postQueryPapers,
  postQueryCoursePapers,
  postQueryChapterPapers,
  paperDefaultType,
  optionItemtype,
  postPapersSubmit,
  papersSubmitType,
  postQueryGeneralPapers,
  postPapersQueryById,
  examStudentSubjectType,
  examPaperStudentDefaultType,
  subjectOptionType,
} from "@/api/request/exam";
// @ts-ignore
import markdownit from "markdown-it";
import { ElMessage, ElMessageBox } from "element-plus";
import moment from "moment";
import gsap from "gsap";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { Radar } from "@antv/g2plot";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const isScore = ref(false);
function goBack(num: number) {
  router.go(num);
}
const saveLoading = ref(false);
function closeDialog() {
  router.replace({
    path: "/operate/courseContent",
    query: {
      id: route.query.courseId,
    },
  });
}
function resetExam() {
  window.location.reload();
}

function openAnswer(examId: string) {
  postPapersQueryById({ id: examId }).then(async (res) => {
    studentDetailsVisible.value = true;
    questionSubjectList.value = [];
    questionList.value = [];
    examDetailData.value = res.data;
    if (res.data.examLabelVOList) {
      res.data.examLabelVOList.forEach((item) => {
        item.subjects.forEach((val) => {
          val.options = JSON.parse(val.options as string);
          val.answer = JSON.parse(val.answer as string);
          // @ts-ignore
          val.studentAnswer = JSON.parse(val.studentAnswer as string);
        });
      });
      questionSubjectList.value = res.data.examLabelVOList;
    }
    if (res.data.studentSubjects) {
      res.data.studentSubjects.forEach((item) => {
        item.options = JSON.parse(item.options as string);
        item.answer = JSON.parse(item.answer as string);
        // @ts-ignore
        item.studentAnswer = JSON.parse(item.studentAnswer as string);
      });
      questionList.value = res.data.studentSubjects;
    }
    if (route.query.type === "exercises") {
      await nextTick();
      initChart(res.data.examStudentRadarVOList);
    }
  });
}
function initChart(
  data: examPaperStudentDefaultType["examStudentRadarVOList"]
) {
  if (!data) return false;
  const radarPlot = new Radar("radarContainer", {
    data: data.map((d) => ({ ...d })),
    xField: "label",
    yField: "score",
    appendPadding: [10, 10, 10, 10],
    meta: {
      score: {
        alias: t("得分"),
        min: 0,
      },
    },
    lineStyle: () => {
      return {
        fill: "#fe2c55",
      };
    },
    xAxis: {
      tickLine: null,
    },
    yAxis: {
      label: false,
      grid: {
        alternateColor: "rgba(0, 0, 0, 0.04)",
      },
    },
    area: {
      color: "#fe2c55",
    },
  });
  radarPlot.render();
}
const studentDetailsVisible = ref(false);
const examDetailData = ref({} as examPaperStudentDefaultType);
const questionList = ref([] as examStudentSubjectType[]);
const questionSubjectList = ref(
  [] as examPaperStudentDefaultType["examLabelVOList"]
);
const scoreInfo = ref({
  examId: "",
  examScores: 0,
  time: "",
  showAnswer: 0,
} as {
  examId: string;
  examScores: number;
  time: string;
  examEndTime?: string;
  /** 是否可以继续考试 */
  examFlag?: boolean;
  /** 考试是否通过 */
  examPassFlag?: boolean;
  examStartTime?: string;
  /** 剩余考试次数 */
  examSurplusNum?: number;
  showAnswer: 0 | 1;
});
let isSave = false;
function paperSave(type: "auto" | "hand") {
  const reqData = {} as papersSubmitType;
  reqData.answerTime = String(answerTime.value);
  reqData.examId = paperInfo.value.businessId;
  reqData.version = paperInfo.value.version;
  reqData.submitType = type === "hand" ? 1 : 2;
  reqData.dtoList = [];
  reqData.scoreReviewId = (route.query.reviewId as string) || undefined;
  let isAnswer = true;
  paperInfo.value.subjects.forEach((item) => {
    if (!item.answer || item.answer.length === 0) {
      item.answer = [];
      isAnswer = false;
    }
    item.answer?.sort(function (a, b) {
      return Number(a) - Number(b);
    });
    reqData.dtoList.push({
      businessId: item.businessId,
      studentAnswer: item.answer as string[],
    });
  });
  if (route.query.type === "course")
    reqData.courseId = route.query.courseId as string;
  if (type === "hand") {
    if (!isAnswer) return ElMessage.error(t("请先答完所有问题"));
    ElMessageBox.confirm(t("请您确认是否提交试卷"), t("提示"), {
      confirmButtonText: t("提交"),
      cancelButtonText: t("继续答题"),
      type: "warning",
    })
      .then(() => {
        save();
      })
      .catch(() => {
        //
      });
  } else {
    save();
  }
  function save() {
    clearTimeout(timer.value);
    if (isSave) return ElMessage.error(t("不要重复提交试卷"));
    isSave = true;
    if (
      !!scoreInfo.value.examEndTime &&
      new Date(scoreInfo.value.examEndTime).getTime() < new Date().getTime()
    ) {
      return ElMessage.error(t("考试已结束"));
    }
    saveLoading.value = true;
    postPapersSubmit(reqData)
      .then(async (res) => {
        if (route.query.type === "label" || route.query.type === "ability") {
          router.push({
            path: "/operate/examResult",
            query: {
              ...route.query,
            },
          });
        } else {
          scoreInfo.value = res.data;
          isScore.value = true;
          await nextTick();
          gsap
            .timeline({
              onComplete: () => {
                console.log("动画完成");
                // isScore.value = false;
                document
                  .getElementsByTagName("body")[0]
                  .classList.remove("g-hidden");
              },
            })
            .to(".scoreDialog", {
              top: "15vh",
            });
        }
      })
      .catch((err) => {
        saveLoading.value = false;
        ElMessage.error(err.msg);
      })
      .finally(() => {
        isSave = false;
      });
  }
}
function numberListToLetter(list: number[] | string[]) {
  const _list = list.flat();
  let data: string[] = [];
  _list.forEach((item) => {
    data.push(numberToLetter(Number(item) + 1));
  });
  return String(data);
}

// 数字转字母
function numberToLetter(number: number) {
  const base = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let result = "";

  while (number > 0) {
    number--;
    const remainder = number % 26;
    result = base[remainder] + result;
    number = Math.floor(number / 26);
  }

  return result;
}
// function numberListToLetter(list: number[]) {
//   let data: string[] = [];
//   list.forEach((item) => {
//     console.log(item);
//     data.push(numberToLetter(item + 1));
//   });
//   return String(data);
// }
// 题目类型
const questionType = {
  "1": t("单选题"),
  "2": t("多选题"),
  "3": t("判断题"),
};
// const questionList = ref([] as { type: "1" | "2" | "3"; subject: string }[]);
const paperInfo = ref({} as paperDefaultType);
const answerTime = ref("");
const isEmpty = ref(false);
const isEnd = ref(false);
onMounted(async () => {
  console.log("onMounted");
  getExam();
});
function getExam() {
  if (route.query.type === "label") {
    postQueryPapers()
      .then((res) => {
        formatData(res.data);
      })
      .catch(() => {
        isEmpty.value = true;
      });
  }
  if (route.query.type === "course") {
    postQueryCoursePapers({ id: route.query.examId as string })
      .then((res) => {
        formatData(res.data);
        if (
          !!paperInfo.value.examEndTime &&
          new Date(paperInfo.value.examEndTime).getTime() < new Date().getTime()
        ) {
          isEnd.value = true;
          ElMessage.error(t("考试已结束"));
        }
        if (!isEnd.value) {
          isEndExam();
        }
      })
      .catch(() => {
        isEmpty.value = true;
      });
  }
  if (route.query.type === "chapter") {
    postQueryChapterPapers({ id: route.query.examId as string })
      .then((res) => {
        formatData(res.data);
      })
      .catch(() => {
        isEmpty.value = true;
      });
  }
  if (route.query.type === "ability" || route.query.type === "exercises") {
    postQueryGeneralPapers({
      id: route.query.examId as string,
      type: route.query.type === "ability" ? "4" : "5",
    })
      .then((res) => {
        formatData(res.data);
      })
      .catch(() => {
        isEmpty.value = true;
      });
  }
}
const timer = ref(0);
// 是否自动结束考试
function isEndExam() {
  timer.value = setTimeout(() => {
    if (
      paperInfo.value.examEndTime &&
      new Date(paperInfo.value.examEndTime).getTime() < new Date().getTime()
    ) {
      clearTimeout(timer.value);
      paperSave("auto");
      return;
    }
    isEndExam();
  }, 1000 * 20);
}
onUnmounted(() => {
  clearTimeout(timer.value);
});
router.afterEach((val) => {
  if (val.path === "/operate/exam") {
    getExam();
  }
});
function formatData(data: paperDefaultType) {
  const md = markdownit();
  if (data.introduction) data.introduction = md.render(data.introduction);
  data.subjects.forEach((item) => {
    item.type = String(item.type) as "1" | "2" | "3";
    item.options = JSON.parse(item.options as string);
    item.answer = [];
  });
  paperInfo.value = data;
  answerTime.value = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_Container = _resolveComponent("Container")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Container, {
      width: "1080px",
      color: "#141618"
    }, {
      default: _withCtx(() => [
        (!isEmpty.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (paperInfo.value.introduction)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "context",
                    innerHTML: paperInfo.value.introduction
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(_toDisplayString(_ctx.$t("试卷题目")), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paperInfo.value.subjects, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "item"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(index + 1) + ".", 1),
                      _createElementVNode("div", _hoisted_9, "[" + _toDisplayString(questionType[item.type]) + "]", 1),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(item.subject), 1)
                    ]),
                    (item.pictures)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pictures.split(','), (val, index) => {
                            return (_openBlock(), _createBlock(_component_el_image, {
                              key: index,
                              src: val,
                              class: "picturesImage max-width-100 max-height-500",
                              "max-scale": 7,
                              "min-scale": 0.2,
                              "preview-src-list": item.pictures.split(','),
                              "initial-index": 4,
                              fit: "cover"
                            }, null, 8, ["src", "min-scale", "preview-src-list"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: item.answer,
                      "onUpdate:modelValue": ($event: any) => ((item.answer) = $event),
                      max: item.type !== '2' ? 1 : undefined,
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options as optionItemtype[], (val, key) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: key,
                              class: "optionItem g-flex-al-center"
                            }, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_el_checkbox, { value: key }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(numberToLetter(key + 1)) + ". " + _toDisplayString(val.answer), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "max"])
                  ]))
                }), 128))
              ]),
              (paperInfo.value.subjects)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_el_button, {
                      round: "",
                      color: "#FE2C55",
                      size: "large",
                      loading: saveLoading.value,
                      disabled: isEnd.value,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (paperSave('hand')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("  " + _toDisplayString(_ctx.$t("提交试卷")) + "  ", 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_el_empty, {
                      description: _ctx.$t('暂无试卷'),
                      image: _unref(noData)
                    }, null, 8, ["description", "image"])
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (isScore.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("您的得分为")), 1),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", null, _toDisplayString(scoreInfo.value.examScores) + _toDisplayString(_ctx.$t("分")), 1)
            ]),
            (_unref(route).query.type !== 'exercises')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (scoreInfo.value.examPassFlag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t("恭喜您通过此次考试！")), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (scoreInfo.value.examSurplusNum && scoreInfo.value.examSurplusNum > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t("很遗憾,您未通过此次考试, 还剩N次考试机会！", {
                  text: scoreInfo.value.examSurplusNum,
                })), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t("很遗憾,您未通过此次考试, 考试机会已用完！")), 1))
                      ])),
                  (
              scoreInfo.value.examEndTime &&
              new Date(scoreInfo.value.examEndTime).getTime() < new Date().getTime()
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t("考试已结束！")), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_el_button, {
                      class: "width-300",
                      round: "",
                      color: "#FE2C55",
                      size: "large",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (closeDialog()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("  " + _toDisplayString(_ctx.$t("继续学习")) + "  ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (scoreInfo.value.showAnswer === 1)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          class: "width-300",
                          color: "#fff",
                          round: "",
                          size: "large",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (openAnswer(scoreInfo.value.examId)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("  " + _toDisplayString(_ctx.$t("查看试卷")) + "  ", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_el_button, {
                      class: "width-300",
                      color: "#FFF",
                      round: "",
                      size: "large",
                      disabled: !scoreInfo.value.examFlag,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (resetExam()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("  " + _toDisplayString(_ctx.$t("重新考试")) + "  ", 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_el_button, {
                      class: "width-300",
                      round: "",
                      color: "#FE2C55",
                      size: "large",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (goBack(-1)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("  " + _toDisplayString(_ctx.$t("返回认证")) + "  ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    (scoreInfo.value.showAnswer === 1)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          class: "width-300",
                          round: "",
                          color: "#FFF",
                          size: "large",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (openAnswer(scoreInfo.value.examId)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("  " + _toDisplayString(_ctx.$t("查看试卷")) + "  ", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_el_button, {
                      class: "width-300",
                      round: "",
                      color: "#FFF",
                      size: "large",
                      disabled: !scoreInfo.value.examFlag,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (resetExam()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("  " + _toDisplayString(_ctx.$t("重新考试")) + "  ", 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ], 64))
          ], 512)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: studentDetailsVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((studentDetailsVisible).value = $event)),
      width: "1000px",
      title: _ctx.$t('学员答题详情'),
      class: "studentDetailsDialog",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        (_unref(route).query.type === 'exercises')
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createVNode(_component_el_descriptions, {
                border: "",
                column: 2,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, {
                    "min-width": "100",
                    label: _ctx.$t('试卷标题')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(examDetailData.value.examPapersTitle), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    "min-width": "100",
                    label: _ctx.$t('试卷时间')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(examDetailData.value.papersTimes) + " " + _toDisplayString(_ctx.$t("考试时长（分钟）")), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _ctx.$t('学员UID')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(examDetailData.value.uid), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _ctx.$t('考试时间')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(examDetailData.value.answerTime), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _ctx.$t('学员名称')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(examDetailData.value.studentName), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _ctx.$t('答题时长')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(examDetailData.value.time), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _ctx.$t('学员类型')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(examDetailData.value.studentTypeRef), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _ctx.$t('考试成绩')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(examDetailData.value.score) + " " + _toDisplayString(_ctx.$t("分")), 1)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _hoisted_33
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          (
            Array.isArray(questionSubjectList.value) && questionSubjectList.value.length > 0
          )
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(questionSubjectList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.labelId,
                  class: "questionLabelItem"
                }, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subjects, (val, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "questionItem g-pl10 g-mt10"
                    }, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          (val.resultFlag === 1)
                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                key: 0,
                                color: "#25F4EE",
                                size: "22"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(CircleCheckFilled))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_icon, {
                                key: 1,
                                color: "#fe2c55",
                                size: "22"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(CircleCloseFilled))
                                ]),
                                _: 1
                              }))
                        ]),
                        _createElementVNode("div", _hoisted_38, _toDisplayString(index + 1) + ".", 1),
                        _createElementVNode("div", _hoisted_39, " [" + _toDisplayString(questionType[val.type as "1" | "2" | "3"]) + "] ", 1),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(val.subject), 1),
                        _createTextVNode(" (" + _toDisplayString(val.score) + " " + _toDisplayString(_ctx.$t("分")) + ") ", 1)
                      ]),
                      (val.pictures)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(val.pictures.split(','), (item, index) => {
                              return (_openBlock(), _createElementBlock("img", {
                                key: index,
                                src: item,
                                alt: ""
                              }, null, 8, _hoisted_42))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_43, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(val.options as subjectOptionType[], (i, key) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: key,
                            class: _normalizeClass(["optionItem g-mr15 g-mb5", val.studentAnswer.includes(key) ? 'active' : ''])
                          }, _toDisplayString(numberToLetter(key + 1)) + ". " + _toDisplayString(i.answer), 3))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createTextVNode(_toDisplayString(_ctx.$t("问题答案")) + "：", 1),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(numberListToLetter([val.answer])), 1)
                      ])
                    ]))
                  }), 128))
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (Array.isArray(questionList.value) && questionList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("全部题目")), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionList.value, (val, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "questionItem g-pl10 g-mt10"
                  }, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        (val.resultFlag === 1)
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              color: "#25F4EE",
                              size: "22"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CircleCheckFilled))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              color: "#fe2c55",
                              size: "22"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CircleCloseFilled))
                              ]),
                              _: 1
                            }))
                      ]),
                      _createElementVNode("div", _hoisted_50, _toDisplayString(index + 1) + ".", 1),
                      _createElementVNode("div", _hoisted_51, " [" + _toDisplayString(questionType[val.type as "1" | "2" | "3"]) + "] ", 1),
                      _createElementVNode("div", _hoisted_52, _toDisplayString(val.subject), 1),
                      _createTextVNode(" (" + _toDisplayString(val.score) + " " + _toDisplayString(_ctx.$t("分")) + ") ", 1)
                    ]),
                    (val.pictures)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(val.pictures.split(','), (item, index) => {
                            return (_openBlock(), _createElementBlock("img", {
                              key: index,
                              src: item,
                              alt: ""
                            }, null, 8, _hoisted_54))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_55, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(val.options as subjectOptionType[], (i, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: _normalizeClass(["optionItem g-mr15 g-mb5", val.studentAnswer.includes(key) ? 'active' : ''])
                        }, _toDisplayString(numberToLetter(key + 1)) + ". " + _toDisplayString(i.answer), 3))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createTextVNode(_toDisplayString(_ctx.$t("问题答案")) + "：", 1),
                      _createElementVNode("span", _hoisted_57, _toDisplayString(numberListToLetter([val.answer])), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})